<template>
  <div class="card-details-container">
    <div class="card-icon">
      <font-awesome-icon
        :icon="cardIcon"
        :style="{color: cardColor}"
        size="6x"
      />
    </div>
    <div class="card-details">
      <div class="cardholder">
        {{ cardholder }}
      </div>
      <div class="card-number">
        <template
          v-for="n in cardNumber.length"
        >
          <div
            v-if="cardNumber[n - 1] === 'x'"
            :key="n"
            class="hidden-digit"
          >
            <div class="inner-digit" />
          </div>
          <div
            v-else
            :key="n"
            class="visible-digit"
          >
            {{ cardNumber[n - 1] }}
          </div>
          <div
            v-if="n > 1 && (n % 4 === 0)"
            :key="'spacer-' + n"
            class="spacer"
          />
        </template>
      </div>
      <div
        v-if="cardExpiry"
        class="card-expiry"
      >
        Expires {{ cardExpiry }}
      </div>
    </div>
    <div class="clear-button">
      <b-btn
        variant="outline-danger"
        @click="clearCardDetails"
      >
        Clear
      </b-btn>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'card-display-integrapay-view-card',
  data() {
    return {
      cards: {
        'mastercard': {
          icon: ['fab', 'cc-mastercard'],
          color: '#ff9900'
        },
        'visa': {
          icon: ['fab', 'cc-visa'],
          color: '#1a1f71'
        },
        'amex': {
          icon: ['fab', 'cc-amex'],
          color: '#002663'
        },
        'discover': {
          icon: ['fab', 'cc-discover'],
          color: '#ff6000'
        },
        'jcb': {
          icon: ['fab', 'cc-jcb'],
          color: '#44a936'
        },
        'diners-club': {
          icon: ['fab', 'cc-diners-club'],
          color: '#0079be'
        }
      }
    }
  },
  computed: {
    ...mapState('somnambulistui', ['payer']),
    cardIcon() {
      if (this.cardType && this.cards[this.cardType]) {
        return this.cards[this.cardType].icon
      }
      else {
        return ['fas', 'credit-card']
      }
    },
    cardColor() {
      if (this.cardType && this.cards[this.cardType]) {
        return this.cards[this.cardType].color
      }
      else {
        return '#495057'
      }
    },
    cardNumber() {
      return this.payer.pan || ''
    },
    cardholder() {
      return this.payer.name
    },
    cardExpiry() {
      let date = dayjs(this.payer.expiry_date ?? this.payer.expdate)
      if (date.isValid()) {
        return date.format('MM/YY')
      }
      return null
    },
    cardType() {
      if (/^(5[1-5])/.test(this.cardNumber)) {
        return 'mastercard'
      }
      else if (/^4/.test(this.cardNumber)) {
        return 'visa'
      }
      else if (/^3(4|7)/.test(this.cardNumber)) {
        return 'amex'
      }
      else if (/^6(011|4|5)/.test(this.cardNumber)) {
        return 'discover'
      }
      else if (/^35((2[8-9])|([3-8][0-9]))/.test(this.cardNumber)) {
        return 'jcb'
      }
      else if (/^3(6|8|9|0([0-5]|95))/.test(this.cardNumber)) {
        return 'diners-club'
      }
      else {
        return null
      }
    }
  },
  methods: {
    ...mapMutations('somnambulistui', ['SET_PAYER', 'SET_PAYER_VALID']),
    clearCardDetails: function() {
      this.SET_PAYER_VALID(false)
    }
  }

}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

  .card-details-container {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    @include media-breakpoint-up('md') {
      flex-direction: row;
      justify-content: flex-start;
      align-content: center;
    }
    .card-icon {
      display: flex;
      flex-grow: 1;
      flex-shrink: 1;
      justify-content: center;
      align-items: center;
      max-width: 100px;
      margin: 0 auto 1em auto;
      @include media-breakpoint-up('md') {
        margin: 0 2em 0 0;
      }
      svg {
        width: 100%;
        height: 100%;
      }
    }
    .clear-button {
      align-self: center;
      button {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.5em;
        svg {
          width: 1em;
          height: 1em;
        }
      }
    }
    .card-details {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      flex-grow: 1;
      flex-shrink: 0;
      .cardholder {
        font-weight: 600;
      }
      .card-number {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 1em;
        .hidden-digit {
          margin-right: 0.3em;
          .inner-digit {
            width: 0.75em;
            height: 0.75em;
            border-radius: 50% 50%;
            background-color: var(--main-highlight-text-color);
          }
        }
        .visible-digit {
          font-size: 1em;
          font-family: monospace;
          margin-right: 0.3em;
        }
        .spacer {
          width: 0.7em;
          height: 1em;
        }
      }
      .card-expiry {
        color: var(--main-highlight-text-color);
        font-weight: 600;
      }
    }
  }
</style>
